import { FC, useState } from 'react';

import { usePage } from '@inertiajs/react';
import { CircleDollarSign } from 'lucide-react';

import { ServiceFeeDetailsDialog } from '../../../components/shared/ServiceFeeDetailsDialog';
import {
    formatServiceFeeDate,
    formatServiceFeeMoney,
    ServiceFeePageProps,
} from '../../../components/shared/serviceFeePresentation';
import { Button } from '../../../components/ui/Button';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '../../../components/ui/Card';

export const ServiceFeeInformationCard: FC = () => {
    const { serviceFeeAnnouncement } = usePage<ServiceFeePageProps>().props;
    const [detailsOpen, setDetailsOpen] = useState(false);

    if (!serviceFeeAnnouncement || serviceFeeAnnouncement.visible) return null;

    const { startsOn, thresholdCents, percentage, maxCents } =
        serviceFeeAnnouncement;
    const startDate = formatServiceFeeDate(startsOn);
    const threshold = formatServiceFeeMoney(thresholdCents);
    const maximumFee = formatServiceFeeMoney(maxCents);

    return (
        <>
            <Card>
                <CardHeader>
                    <div className="flex items-start gap-3">
                        <div className="rounded-full bg-primary/10 p-2 text-primary">
                            <CircleDollarSign className="h-5 w-5" />
                        </div>
                        <div className="space-y-1">
                            <CardTitle className="text-xl">
                                Сервісний збір CartOn
                            </CardTitle>
                            <CardDescription className="leading-relaxed">
                                {percentage}% із завершених продажів більше{' '}
                                {threshold} — максимум {maximumFee} за
                                замовлення.
                            </CardDescription>
                        </div>
                    </div>
                </CardHeader>
                <CardContent>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={() => setDetailsOpen(true)}
                    >
                        Детальні умови
                    </Button>
                </CardContent>
            </Card>

            <ServiceFeeDetailsDialog
                open={detailsOpen}
                onOpenChange={setDetailsOpen}
                startDate={startDate}
                threshold={threshold}
                percentage={percentage}
                maximumFee={maximumFee}
            />
        </>
    );
};
